import { render, staticRenderFns } from "./HelpIndex.vue?vue&type=template&id=72fc3ffc&scoped=true&"
import script from "./HelpIndex.vue?vue&type=script&lang=ts&"
export * from "./HelpIndex.vue?vue&type=script&lang=ts&"
import style0 from "./HelpIndex.vue?vue&type=style&index=0&id=72fc3ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc3ffc",
  null
  
)

export default component.exports